import VModal from '@/vuetify_custom/v-modal_v1'
import VForm from '@/vuetify_custom/v-form'
import {mapGetters} from "vuex";
import ReceiptFiveSelectMixins from '@/views/fin_bill/mixins/receipt_five_select_mixins.js'
import {postSalaryCustomerFunctionMappingSaveApi} from './service'
const d = val => !!val || '必选'
const createParams = () => ({
    "id": null,
    "sales_employment_type": null,
    "sales_employment_type_id": null,
    "customer_function_id":false,
})

export default {
    mixins:[ReceiptFiveSelectMixins],
    data() {
        return {
            show:false,
            loading:false,
            expense:createParams(),
            expect_finish_date: null,
        
        }
    },
    computed: {
        ...mapGetters('async', [
            'customer_functions',
            'sales_employment_types',
            'sales_employment_types_hash'
          ]),
     
        fields() {
            return [
                {
                    label: '工作内容',
                    type:'autocompletes',
                    key:'sales_employment_type_id',
                    items: this.sales_employment_types,
                    'item-value':'item_id',
                    'item-text':'item_text',
                    'item-disabled': 'del',
                    placeholder: this.sales_employment_types.length ? '请选择' : '无可选项',
                    disabled:!this.filter_customer_functions.length,
                    rules:[d],
                    cols: 12,
                    clearable: true,
                    required: true,
                    change:(val) => {
                         const item = this.sales_employment_types_hash[val]
                         this.expense.sales_employment_type = item.item_text
                    }
                       
                },
                {
                    ...this.customer_function_field,
                    required: true,
                    cols: 12,
                    disabled: false,
                    rules:[d]
                }, // 员工职能
        
    
            ]
        }
    },
    methods: {
        edit(data) {
            const y = createParams()
       if (data) {
        Object.keys(y).forEach(key => {
            y[key] = data[key]
        })    
       } 
       this.expense = y
            this.show = true
      
            setTimeout(() => {
                this.$refs.form && this.$refs.form.resetValidation()
            }, 50)
        },
        submit() {
            if (this.$refs.form.validate()) {
                this.loading = true
                postSalaryCustomerFunctionMappingSaveApi(this.expense).then(() => {
                    this.$Message.success('数据提交成功！')
                    this.$emit('success')
                    this.show = false
                }).finally(() => {
                    this.loading = false
                })
     
            }
        }
    },
    render() {
        return <VModal
        v-model={this.show}
        dynamicHeight
        heightRate={0.5}
        title={this.expense.id ? '编辑' : '新增'}
        loading={this.loading}
        width={600}
        ref="modal"
        ok-text="保存"
        on={{
            ok: () => {
                this.submit() 
            },
        }}
        >
            <VForm 
                ref="form" 
                fields={this.fields} 
                v-model={this.expense}
                
            />
        </VModal>
    }
}